import * as React from "react";
import { useCanceledBooking } from "./useCanceledBooking";
import { AsButton, Header, RequestedPayment } from "app/subframe";

export interface CanceledBookingProps {}

export const CanceledBooking: React.FC<CanceledBookingProps> = ({}) => {
  const { onReschedulePress, account, refund } = useCanceledBooking();

  return (
    <div className="flex h-[95dvh] my-4 pb-4 grow shrink-0 basis-0 flex-col items-center gap-4 rounded-2xl bg-white overflow-auto shadow-md mobile:w-full mobile:grow mobile:shrink-0 mobile:basis-0">
      {" "}
      <Header
        className="h-auto w-[600px] flex-none mobile:h-auto mobile:w-full mobile:flex-none"
        image={account?.logo}
        text={account?.name}
      />
      <div className="flex w-[600px] grow shrink-0 basis-0 flex-col items-center gap-20 px-2 mobile:w-full mobile:grow mobile:shrink-0 mobile:basis-0 mobile:flex-col mobile:gap-6 mobile:px-2 mobile:py-0">
        <RequestedPayment
          text={`Your appointment with ${account?.name} has been cancelled.`}
          single={true}
        />
        {refund.status === "refunded" && (
          <span className="text-center text-[14px] leading-[20px] text-neutral-700">
            ${(refund.cents / 100).toFixed(2)} is being refunded to your card. It can take a few days to show.
          </span>
        )}
        {refund.status === "failed" && (
          <span className="text-center text-[14px] leading-[20px] text-neutral-700">
            We couldn't refund your payment automatically. Please contact the shop so they can refund it.
          </span>
        )}
        <AsButton
          className="h-14 w-full flex-none"
          text="Book again"
          size="lg"
          loader={false}
          disabled={false}
          disabledSecondary={false}
          onClick={() => onReschedulePress()}
        />
      </div>
    </div>
  );
};
